import { useEffect, useState, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

import { GetDynamics as BLGetDynamics, SetDynamic as BLSetDynamic, DeleteDynamicData } from './../../../utilities/BL/Admin/Dashboard/Dynamics'
import { ResetAllResults, SetGenderMode, GetGenderMode as BLGetGenderMode, GetAutozoneState as BLGetAutozoneState, SetAutozoneState as BLSetAutozoneState } from './../../../utilities/BL/Zones'

import { RunToGoal } from './../Games/RunToGoal'
import { RunToGoalV2 } from './../Games/RunToGoalV2'
import { RunToGoalV3 } from './../Games/RunToGoalV3'
import { Base } from './../Commons/Base'
import { Quiz } from './../Games/Quiz'
import { Colors } from './../Games/Colors'
import { Lottery } from './../Games/Lottery'
import { Balloons } from '../Games/Balloons'
import { Riddle } from './../Games/Riddle'
import { SelfieFan } from './../Games/SelfieFan'
import { SelfieFanPlayer } from './../Games/SelfieFanPlayer'
import { QuizzWithImageAndOptions } from './../Games/QuizzWithImageAndOptions'
import { Karaoke } from './../Games/Karaoke'
import { LuchoFest } from './../Games/LuchoFest'
import { LightShow } from './../Games/LightShow'
import { Picnic } from './../Games/Picnic'
import { Tacos } from './../Games/Tacos'
import { Noisemeter } from './../Overlays/Noisemeter'
import { Messages } from './../Overlays/Messages'
import { PluckingRooster } from './../Overlays/PluckingRooster'
import { InteractiveChat } from './../Overlays/InteractiveChat'
import { Briefcase } from './../Games/Briefcase'

import { Sections } from './Sections'
import { CatchTheBall } from './../Games/CatchTheBall'
import { SlotMachine } from './../Games/SlotMachine'

import { Stadium } from './../Games/Stadium'
import { Voting } from './../Games/Voting'
import { Caps } from './../Games/Caps'
import { Roulette } from './../Games/Roulette'
import { CarreraContinua } from './../Games/CarreraContinua'
import { PersonalNoisemeter } from './../PersonalNoisemeter/PersonalNoisemeter'

const RoomControlPanel = () => {
    // --- ESTADOS DE CONTROL DE SALA SaaS ---
    const [activeRooms, setActiveRooms] = useState([]);
    const [selectedRoom, setSelectedRoom] = useState(null);
    const [loadingRooms, setLoadingRooms] = useState(true);

    // --- ESTADOS DEL DASHBOARD REUTILIZADOS ---
    const [dynamics, setDynamics] = useState([]);
    const [currentDynamic, setCurrentDynamic] = useState(null);
    const [currentMessage, setCurrentMessage] = useState(null);
    const [isActiveWomensMode, setActiveWomensMode] = useState(null);
    const [isAutozoneActive, setAutozoneActive] = useState(null);

    // --- MAPA DE ICONOS ---
    const ICONS_MAP = {
        1: 'bi bi-qr-code-scan',
        2: 'bi bi-hourglass-split',
        3: 'bi bi-check2-circle',
        4: 'bi bi-ui-checks-grid',
        5: 'bi bi-noise-reduction',
        6: 'bi bi-palette',
        7: 'bi bi-person-raised-hand',
        8: 'bi bi-chat-square-heart',
        9: 'bi bi-balloon',
        10: 'bi bi-question-square',
        12: 'bi bi-qr-code-scan',
        13: 'bi bi-gitlab',
        14: 'bi bi-camera',
        15: 'bi bi-file-music',
        16: 'bi bi-speedometer2',
        17: 'bi bi-chat-left-quote',
        18: 'bi bi-qr-code-scan',
        19: 'bi bi-qr-code-scan',
        20: 'bi bi-controller',
        21: 'bi bi-list-ol',
        22: 'bi bi-cake2',
        23: 'bi bi-phone-vibrate',
        24: 'bi bi-chat',
        25: 'bi bi-basket-fill',
        26: 'bi bi-briefcase',
        27: 'bi bi-fork-knife',
        28: 'bi bi-controller',
        29: 'bi bi-coin',
        30: 'bi bi-gear',
        31: 'bi bi-question-circle',
        32: 'bi bi-mortarboard-fill',
        33: 'bi bi-record-circle',
        39: 'bi bi-person-walking',
        40: 'bi bi-megaphone-fill'
    };

    const DYNAMIC_SECTIONS_CONFIG = [
        {
            title: 'Mensajes del aficionado',
            icon: 'bi bi-chat-square-quote',
            ids: [7, 2, 1, 8, 12, 18, 19, 21]
        },
        {
            title: 'Aficionados',
            icon: 'bi bi-people',
            ids: [14, 23]
        },
        {
            title: 'Overlays',
            icon: 'bi bi-window-desktop',
            ids: [15, 17, 20, 24]
        },
        {
            title: 'Dinámicas 1 vs 1',
            icon: 'bi bi-controller',
            ids: [5, 9, 10, 13, 16, 22, 25, 26, 27, 28, 29, 32, 33, 39, 40]
        },
        {
            title: 'Dinámicas multijugador',
            icon: 'bi bi-controller',
            ids: [3, 4, 6, 9, 10, 13, 16, 22, 29, 31, 39, 40]
        },
        {
            title: 'Configuraciones',
            icon: 'bi bi-gear',
            ids: [30]
        }
    ];

    // =========================================================================
    // INTERCEPTOR DE FETCH GLOBAL (Inyección de roomId contextual en headers)
    // =========================================================================
    useEffect(() => {
        if (selectedRoom) {
            const originalFetch = window.fetch;
            window.fetch = function (url, options = {}) {
                options.headers = options.headers || {};
                
                // Si las headers son de tipo Headers (Fetch API nativo)
                if (options.headers instanceof Headers) {
                    options.headers.set('X-Room-Id', selectedRoom.id);
                    options.headers.set('roomId', selectedRoom.id);
                } else {
                    options.headers['X-Room-Id'] = selectedRoom.id;
                    options.headers['roomId'] = selectedRoom.id;
                }
                return originalFetch(url, options);
            };

            // Recargar datos específicos de la sala en la UI
            LoadRoomStates();

            return () => {
                window.fetch = originalFetch;
            };
        }
    }, [selectedRoom]);

    // Carga de salas activas
    const GetActiveRooms = async () => {
        try {
            setLoadingRooms(true);
            const apiBase = process.env.REACT_APP_API_URL || 'https://localhost:50586/api/';
            const res = await fetch(`${apiBase}v2/rooms/active`);
            if (res.ok) {
                const data = await res.json();
                setActiveRooms(data);
            } else {
                console.error("Error al obtener salas activas:", res.status);
            }
        } catch (err) {
            console.error("Error cargando salas activas:", err);
        } finally {
            setLoadingRooms(false);
        }
    };

    const LoadRoomStates = async () => {
        try {
            await GetDynamics();
            await GetGenderMode();
            await GetAutozoneMode();
        } catch (err) {
            console.error("Error al cargar estados de la sala:", err);
        }
    };

    const GetGenderMode = async () => {
        try {
            const response = await BLGetGenderMode()
            if (response.success) {
                setActiveWomensMode(response.data.isWomensModeActive)
            }
        } catch (error) {
            console.error(error);
        }
    }

    const SetWomensMode = async (activeWomensMode) => {
        try {
            const response = await SetGenderMode(activeWomensMode)
            if (response.success) {
                setActiveWomensMode(activeWomensMode)
            }
        } catch (error) {
            console.error(error);
        }
    }

    const GetAutozoneMode = async () => {
        try {
            const response = await BLGetAutozoneState();
            if (response.success) {
                setAutozoneActive(response.data.isAutozoneActive);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const SetAutozoneMode = async (enabled) => {
        try {
            const response = await BLSetAutozoneState(enabled);
            if (response.success) {
                setAutozoneActive(enabled);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const GetOutOfTheDynamic = async () => {
        try {
            const response = await DeleteDynamicData()
            if (response.success) {
                document.getElementById("root").classList.remove("Colors__Background__Theme1")
                document.getElementById("root").classList.remove("Colors__Background__Theme2")
                setCurrentDynamic(null)
            }
        } catch (error) {
            console.error(error);
        }
    }

    const GetDynamics = async () => {
        try {
            const response = await BLGetDynamics();
            if (response.success) setDynamics(response.data);
        } catch (error) {
            console.error(error);
        }
    };

    const handleDynamicClick = async (dynamic) => {
        try {
            const response = await BLSetDynamic(dynamic.id);
            if (response.success) {
                if ([3, 4, 5, 9, 10, 11, 13, 14, 15, 16, 17, 20, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 39, 40].includes(dynamic.id)) {
                    await ResetAllResults();
                    setCurrentDynamic(dynamic.id);
                    setCurrentMessage(null);
                } else if (dynamic.id === 6) {
                    setCurrentDynamic(6);
                    setCurrentMessage(null);
                } else {
                    setCurrentDynamic(null);
                    setCurrentMessage(dynamic.id);
                }
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        GetActiveRooms();
        document.getElementById("root").classList.add("BodyComplete");
        return () => {
            document.getElementById("root").classList.remove("Colors__Background__Theme1", "Colors__Background__Theme2");
        };
    }, []);

    const zoneSectionData = useMemo(() => ({
        title: 'Asignación de zona',
        icon: 'bi bi-shuffle',
        tiles: [
            { id: 'manual', name: 'Manual', icon: 'bi bi-ui-checks', visible: true, enabled: true, action: () => SetAutozoneMode(false), isActive: isAutozoneActive === false },
            { id: 'auto', name: 'Automática', icon: 'bi bi-magic', visible: true, enabled: true, action: () => SetAutozoneMode(true), isActive: isAutozoneActive === true }
        ]
    }), [isAutozoneActive]);

    const genderSectionData = useMemo(() => ({
        title: 'Modo',
        icon: 'bi bi-controller',
        tiles: [
            { id: 'male', name: 'Varonil', icon: 'bi bi-person-standing', visible: true, enabled: true, action: () => SetWomensMode(false), isActive: isActiveWomensMode === false },
            { id: 'female', name: 'Femenil', icon: 'bi bi-person-standing-dress', visible: true, enabled: true, action: () => SetWomensMode(true), isActive: isActiveWomensMode === true }
        ]
    }), [isActiveWomensMode]);

    const TEMPLATE_TO_OPTION_IDS = useMemo(() => ({
        trivia: [3, 13],
        roulette: [33],
        slot: [29],
        balloons: [9],
        riddle: [10],
        luchofest: [22],
        goal: [5],
        runtogoal: [5],
        picnic: [25],
        tacos: [27],
        noisemeter: [16],
        selfiefan: [14, 11],
        voting: [31],
        caps: [32],
        briefcase: [26],
        catchtheball: [28],
        colors: [6],
        lottery: [4],
        lightshow: [23],
        carreracontinua: [39],
        personalnoisemeter: [40],
        gritomexicano: [40]
    }), []);

    const processedDynamicSections = useMemo(() => {
        if (!dynamics || dynamics.length === 0) return [];

        const templateName = selectedRoom?.gameTemplateName?.toLowerCase();
        const allowedIds = templateName ? (TEMPLATE_TO_OPTION_IDS[templateName] || []) : null;

        return DYNAMIC_SECTIONS_CONFIG.map(sectionConfig => {
            const sectionTiles = sectionConfig.ids
                .filter(id => !allowedIds || allowedIds.includes(id))
                .map(id => {
                    const apiData = dynamics.find(d => d.id === id);
                    if (!apiData) return null;
                    return {
                        ...apiData,
                        icon: ICONS_MAP[id] || 'bi bi-question-circle',
                        action: () => handleDynamicClick(apiData)
                    };
                })
                .filter(Boolean);

            return {
                title: sectionConfig.title,
                icon: sectionConfig.icon,
                tiles: sectionTiles
            };
        }).filter(section => section.tiles.length > 0);
    }, [dynamics, selectedRoom]);

    if (!selectedRoom) {
        return (
            <Base>
                <div className="container mt-5 text-dark" style={{ minHeight: '80vh' }}>
                    <div className="row mb-4">
                        <div className="col text-center">
                            <h2 className="display-5 fw-bold text-primary mb-2">Panel de Control de Salas</h2>
                            <p className="text-muted fs-5">Selecciona una sala activa para enviar comandos contextualizados</p>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-10 col-lg-8">
                            <div className="card shadow-sm border-0 rounded-3">
                                <div className="card-header bg-primary text-white py-3">
                                    <h5 className="mb-0 fw-semibold d-flex align-items-center">
                                        <i className="bi bi-door-open-fill me-2"></i> Salas Activas Comerciales
                                    </h5>
                                </div>
                                <div className="card-body p-4 bg-light">
                                    {loadingRooms ? (
                                        <div className="text-center py-5">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Cargando salas...</span>
                                            </div>
                                            <p className="mt-3 text-muted">Buscando salas en la plataforma...</p>
                                        </div>
                                    ) : activeRooms.length === 0 ? (
                                        <div className="text-center py-5">
                                            <i className="bi bi-exclamation-triangle-fill text-warning display-4 mb-3"></i>
                                            <h4 className="fw-semibold">No se encontraron salas activas</h4>
                                            <p className="text-muted">Asegúrate de que existan eventos activos con salas configuradas en el sistema.</p>
                                            <button className="btn btn-primary mt-3" onClick={GetActiveRooms}>
                                                <i className="bi bi-arrow-clockwise me-1"></i> Reintentar
                                            </button>
                                        </div>
                                    ) : (
                                        <div className="row row-cols-1 row-cols-md-2 g-3">
                                            {activeRooms.map((room) => (
                                                <div key={room.id} className="col">
                                                    <div 
                                                        className="card h-100 border border-2 border-transparent hover-shadow transition-all pointer-event cursor-pointer"
                                                        style={{ cursor: 'pointer', transition: 'all 0.2s ease-in-out', borderRadius: '12px' }}
                                                        onClick={() => setSelectedRoom(room)}
                                                    >
                                                        <div className="card-body p-3 d-flex align-items-center justify-content-between">
                                                            <div>
                                                                <h6 className="fw-bold mb-1 text-dark">{room.nombreSala}</h6>
                                                                <span className="badge bg-secondary me-2">
                                                                    {room.gameTemplateName || 'Sin Juego'}
                                                                </span>
                                                                {room.isDefault && (
                                                                    <span className="badge bg-success">Global</span>
                                                                )}
                                                            </div>
                                                            <i className="bi bi-chevron-right text-primary fs-4"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Base>
        );
    }

    return (
        <>
            <div className="bg-primary text-white py-2 px-4 d-flex align-items-center justify-content-between shadow-sm sticky-top">
                <div className="d-flex align-items-center">
                    <button className="btn btn-link text-white p-0 me-3" onClick={() => setSelectedRoom(null)}>
                        <i className="bi bi-arrow-left-circle fs-3"></i>
                    </button>
                    <div>
                        <span className="text-white-50 small d-block">SALA ACTUAL</span>
                        <strong className="fs-5">{selectedRoom.nombreSala}</strong>
                    </div>
                </div>
                <div>
                    <span className="badge bg-light text-primary me-2 px-3 py-2 fs-6">
                        {selectedRoom.gameTemplateName || 'Sin Dinámica'}
                    </span>
                    <button className="btn btn-outline-light btn-sm" onClick={() => setSelectedRoom(null)}>
                        Cambiar Sala
                    </button>
                </div>
            </div>

            {currentDynamic ? (
                currentDynamic === 3 ? <Quiz getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 4 ? <Lottery getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 5 ? <RunToGoalV3 getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 6 ? <Colors getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 9 ? <Balloons getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 10 ? <Riddle getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 11 ? <SelfieFan getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 13 ? <QuizzWithImageAndOptions getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 14 ? <SelfieFanPlayer getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 15 ? <Karaoke getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 16 ? <Noisemeter getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 17 ? <Messages getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 20 ? <PluckingRooster getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 22 ? <LuchoFest getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 23 ? <LightShow getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 24 ? <InteractiveChat getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 25 ? <Picnic getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 26 ? <Briefcase getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 27 ? <Tacos getOutOfTheDynamic={GetOutOfTheDynamic} roomId={selectedRoom.id} /> :
                currentDynamic === 28 ? <CatchTheBall getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 29 ? <SlotMachine getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 30 ? <Stadium getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 31 ? <Voting getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 32 ? <Caps getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 33 ? <Roulette getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 39 ? <CarreraContinua getOutOfTheDynamic={GetOutOfTheDynamic} roomId={selectedRoom.id} /> :
                currentDynamic === 40 ? <PersonalNoisemeter getOutOfTheDynamic={GetOutOfTheDynamic} roomId={selectedRoom.id} /> : null
            ) : (
                <Base>
                    <div className='AdmDashboard'>
                        <p className='AdmDashboard__Title'>Consola de Operador</p>
                        <p className='AdmDashboard__Subtitle'>Señales dirigidas para {selectedRoom.nombreSala}</p>

                        <div className='AdmDashboard__Container'>
                            <Sections
                                title={zoneSectionData.title}
                                sectionIcon={zoneSectionData.icon}
                                tiles={zoneSectionData.tiles}
                                onTileClick={(tile) => tile.action()}
                                activeId={zoneSectionData.tiles.find(t => t.isActive)?.id}
                            />

                            <Sections
                                title={genderSectionData.title}
                                sectionIcon={genderSectionData.icon}
                                tiles={genderSectionData.tiles}
                                onTileClick={(tile) => tile.action()}
                                activeId={genderSectionData.tiles.find(t => t.isActive)?.id}
                            />

                            {processedDynamicSections.map((section, index) => (
                                <Sections
                                    key={index}
                                    title={section.title}
                                    sectionIcon={section.icon}
                                    tiles={section.tiles}
                                    onTileClick={(tile) => tile.action()}
                                    activeId={currentMessage}
                                />
                            ))}
                        </div>
                    </div>
                </Base>
            )}
        </>
    );
};

export default RoomControlPanel;
